import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Experience Our Next-Gen Web Development Services in KSA</h2>
            <p>
              You can unlock the full potential of your business by building a
              powerful online presence with our proven web development
              solutions. As a leading website development company in Saudi
              Arabia, we have expertise in providing high-quality website
              development services customized to the unique requirements of your
              business.
            </p>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>UI/UX Design</h4>
                  <p>
                    Our UI/UX design services combine both pleasing design
                    elements and complex functionality to provide a next-level
                    user experience. We ensure that your website attracts and
                    engages the audience with our expertise in website
                    development and design. As a result, we can help you drive
                    conversions and enhance brand credibility.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Backend Development</h4>
                  <p>
                    As a considerable website development company in Saudi
                    Arabia, we outshine backend development. Our expert
                    developers lay the foundation for scalable web applications
                    that can easily streamline your business operations. We use
                    the latest technologies and best practices to develop
                    efficient backend systems with optimal functionality.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Website Development</h4>
                  <p>
                    You can enhance your online presence with our custom website
                    development solutions. As an experienced website development
                    agency, we understand that every business is unique. That’s
                    why we customize our development process by utilizing
                    technologies like PHP, Java, and Python web development to
                    meet your specific requirements and with precision.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CMS Development</h4>
                  <p>
                    We enable businesses to control their website's content with
                    our expert CMS development services. As a leading website
                    development company in Saudi Arabia, we facilitate you with
                    user-friendly content management systems including WordPress
                    website development. With our CMS solutions, you can easily
                    manage your business operations line.
                  </p>
                </div>

                <div className="robust-content">
                  <h4>Ecommerce Web Development</h4>
                  <p>
                    You can increase your online sales and revenue with our
                    comprehensive ecommerce web development solutions. Our team
                    of website development experts specializes in building
                    dynamic and feature-rich ecommerce websites. With our
                    Shopify website development, we can build your online store
                    while enhancing the overall shopping experience.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
